export const getToken = (price, country, currency, success = () => { }) => {
  console.log('stripe price-------', price, country, currency)
  return new Promise((resolve, reject) => {
    if (window.stripe) {
      const paymentRequest = window.stripe.paymentRequest({
        country: country || process.env.VUE_APP_COUNTRY, // process.env.VUE_APP_COUNTRY,
        // Stripe要求货币码小写,后端configDetails.currency可能返回大写(如EUR),不转会导致paymentRequest创建失败,canMakePayment永远为false
        currency: (currency || process.env.VUE_APP_CURRENCY).toLowerCase(), // process.env.VUE_APP_CURRENCY,
        total: {
          label: process.env.VUE_APP_NAME,
          amount: price * 100
        },
        requestPayerName: false,
        requestShipping: false,
        requestPayerEmail: false
      })
      // Check the availability of the Payment Request API first.
      paymentRequest.canMakePayment().then((result) => {
        console.log('stripepay result', result, paymentRequest)
        // 只认苹果/谷歌钱包:安卓上Google Pay不可用时Stripe会返回{link:true},
        // 放行的话show()会跳转Link收银台(checkout.link.com)而非谷歌钱包
        if (result && (result.applePay || result.googlePay)) {
          resolve(paymentRequest)
        } else {
          reject(new Error('当前环境不支持'))
        }
      }).catch(error => {
        reject(error)
      })
      paymentRequest.on('token', (ev) => {
        console.log('tokentoken', ev.token.id)
        success(ev.token.id, ev)
      })
    } else {
      reject(new Error('stripe还没加载完成'))
    }
  })
}
